import { AllSearchResults, SearchType } from '@/app/(main)/_components/search-modal/search-modal.types';

type FilterTabValue = keyof AllSearchResults;

type FilterTab = {
  value: FilterTabValue;
  label: string;
};

const FILTER_TABS: FilterTab[] = [
  { value: SearchType.ALL, label: 'Todos' },
  { value: SearchType.PROCEDURE, label: 'Atendimentos' },
  { value: SearchType.PROFESSIONAL, label: 'Profissionais' },
  { value: SearchType.PARTNER, label: 'Locais' },
];

export function resolveFilterTabs(results: AllSearchResults): FilterTab[] {
  return FILTER_TABS
    .filter((tab) => results[tab.value].results.length > 0)
    .filter((tab, _, withResults) => (withResults.length === 2 ? tab.value !== SearchType.ALL : true));
}

export function resolveActiveFilter(results: AllSearchResults, selectedFilter?: string): FilterTabValue {
  const tabs = resolveFilterTabs(results);
  const selectedTab = tabs.find((tab) => tab.value === selectedFilter);

  if (selectedTab) {
    return selectedTab.value;
  }

  return tabs.length === 1 ? tabs[0].value : SearchType.ALL;
}
